import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Alert,
  Card,
  CardContent,
  Chip,
} from '@mui/material';
import { CheckCircle, Dashboard, Email } from '@mui/icons-material';

const UnlockSuccessPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const interviewId = searchParams.get('interview');

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
          <CheckCircle sx={{ fontSize: 80, color: 'success.main' }} />
          
          <Typography variant="h4" component="h1" textAlign="center" gutterBottom>
            Unlock Request Approved
          </Typography>

          <Card sx={{ width: '100%', maxWidth: 600 }}>
            <CardContent>
              <Alert 
                severity="success" 
                icon={<CheckCircle />}
                sx={{ mb: 3 }}
              >
                <Typography variant="h6" gutterBottom>
                  Interview Successfully Unlocked
                </Typography>
                <Typography>
                  The candidate's interview has been unlocked and they can now restart their session.
                </Typography>
              </Alert>

              {interviewId && (
                <Box sx={{ mb: 3 }}>
                  <Typography variant="subtitle2" color="text.secondary" gutterBottom>
                    Interview ID
                  </Typography>
                  <Chip 
                    label={interviewId} 
                    variant="outlined" 
                    sx={{ fontFamily: 'monospace' }}
                  />
                </Box>
              )}

              <Box sx={{ bgcolor: 'grey.50', p: 2, borderRadius: 1, mb: 3 }}>
                <Typography variant="subtitle1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Email sx={{ fontSize: 20 }} />
                  What happens next?
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  • The candidate has been automatically notified via email
                  • They can now return to their interview and restart the session
                  • The unlock approval is logged in the interview audit trail
                  • You can review the interview progress in your dashboard
                </Typography>
              </Box>

              <Box display="flex" gap={2} justifyContent="center" flexWrap="wrap">
                <Button 
                  variant="contained" 
                  startIcon={<Dashboard />}
                  onClick={() => navigate('/dashboard')}
                >
                  Return to Dashboard
                </Button>
                
                {interviewId && (
                  <Button 
                    variant="outlined" 
                    onClick={() => navigate(`/interviews/${interviewId}`)}
                  >
                    View Interview Details
                  </Button>
                )}
              </Box>
            </CardContent>
          </Card>

          <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mt: 2 }}>
            If you have any questions about this unlock request, please contact support.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
};

export default UnlockSuccessPage;